module.exports = __webpack_public_path__ + "img/header-weddingRingsTwoColors@2x.b59c230.jpg";